import React, { useEffect, useState } from 'react'
import './distribute-review-item.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import gem from '@/assets/icons/xp.png';
import coin from '@/assets/icons/coin.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import Modal from '@/components/modal/modal.component';
import RewardsForm from '../create-elements/blocks/rewards-form.component';
import EditDistributeModal from './edit-distribute-modal.component';

const DistributeReviewItem = ({
    playerObj,
    gameElements,
    disabled,
    gameData,
    saveIndDistribution
}) => {
    
    const [ showEditModal, setShowEditModal ] = useState(false);
    const [ earningsArray ] = useState([
        'opt_earnedPoints',
        'opt_earnedCurrency',
        'opt_earnedBadges',
        'opt_earnedItems',
        'opt_earnedPrizePacks'
    ]);

    return (
        <div className="distribute-review-item">
            <div className='name-icon g-list-item'>
                {
                    (playerObj.icon)
                    ?
                    <ImageContainer 
                        src={playerObj.icon} 
                        className='icon' 
                        alt='player icon' />
                    :
                    <div 
                        className='gradient' 
                        style={{
                            'background': playerObj.gradient
                        }}>
                        {playerObj.fName[0]}
                    </div> 
                }
                <div className='name'>
                    {playerObj.fName} {playerObj.lName}
                </div>
                <div>
                    <button 
                        className='g-button small-btn'
                        onClick={() => setShowEditModal(true)}
                    >
                        <FontAwesomeIcon icon={faPen} />
                    </button>
                </div>
            </div>
            {
                earningsArray.map(key => {
                    const itemToDistribute = playerObj.distribution[key];
                    if (
                        !itemToDistribute || 
                        (
                            typeof itemToDistribute === 'object' &&
                            Object.values(itemToDistribute).length === 0
                        )
                    ) {
                        return null;
                    }
                    return (
                        <div 
                            className='distribution-content' 
                            key={key} >
                            {
                                (key === 'opt_earnedPoints') &&
                                <>
                                    <div className='dist-title meta'>
                                        XP
                                    </div>
                                    <div className='earned-item'>
                                        <div className='item-div'>
                                            <img src={gem} />
                                        </div>
                                        <div>
                                            {itemToDistribute.toLocaleString('en-US')}
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                (key === 'opt_earnedCurrency') &&
                                <>
                                    <div className='dist-title meta'>
                                        Currency
                                    </div>
                                    <div className='earned-item'>
                                        <div className='item-div'>
                                            <img src={coin} />
                                        </div>
                                        <div>
                                            {itemToDistribute.toLocaleString('en-US')}
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                (key === 'opt_earnedBadges') &&
                                <>
                                {
                                    itemToDistribute.length > 0 &&
                                    <div className='dist-title meta'>Badges</div>
                                }
                                {
                                    itemToDistribute.map((badgeId, badgeIndex) => {
                                        const badge = gameElements[badgeId];
                                        if (!badge) return null;
                                        return (
                                            <div 
                                                className='earned-item' 
                                                key={badgeId}>
                                                <div className='item-div'>
                                                    <ImageContainer src={badge.icon} />
                                                </div>
                                                <div>
                                                    {badge.name}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                </>
                            }
                            {
                                (key === 'opt_earnedItems') &&
                                <>
                                {
                                    Object.values(itemToDistribute).length > 0 &&
                                    <div className='dist-title meta'>Items</div>
                                }
                                {
                                    Object.values(itemToDistribute).map((item, itemIndex) => {
                                        const itemElement = gameElements[item.id];
                                        if (!itemElement) return null;
                                        return (
                                            <div 
                                                className='earned-item three-elements' 
                                                key={item.id}>
                                                <div className='item-div'>
                                                    <ImageContainer src={itemElement.icon} />
                                                </div>
                                                <div>
                                                    {itemElement.name}
                                                </div>
                                                <div className='quantity'>
                                                    x {item.quantity.toLocaleString('en-US')}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                </>
                            }
                            {
                                (key === 'opt_earnedPrizePacks') &&
                                <>
                                    {
                                        Object.values(itemToDistribute).length > 0 &&
                                        <div className='dist-title meta'>Prize Packs</div>
                                    }
                                    {
                                        Object.values(itemToDistribute)
                                        .map((pack, packIndex) => {
                                            const packElement = gameElements[pack.id];
                                            if (!packElement) return null;
                                            return (
                                                <div 
                                                    className='earned-item three-elements' 
                                                    key={pack.id}>
                                                    <div className='item-div'>
                                                        <ImageContainer src={packElement.icon} />
                                                    </div>
                                                    <div>
                                                        {packElement.name}
                                                    </div>
                                                    <div className='quantity'>
                                                        x {pack.quantity.toLocaleString('en-US')}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </>
                            }
                        </div>
                    )
                })
            }
            <div className='g-space-0-5'></div>
            <EditDistributeModal
                showEditModal={showEditModal}
                cancelModal={() => setShowEditModal(false)}
                playerObj={playerObj}
                gameElements={gameElements}
                saveIndDistribution={saveIndDistribution}
                disabled={disabled}
                gameData={gameData}
            />
        </div>
    )
}

export default DistributeReviewItem